import { render } from "./OnDemandAssessmentPurchasesClosed.vue?vue&type=template&id=7bf15bfa&scoped=true"
import script from "./OnDemandAssessmentPurchasesClosed.vue?vue&type=script&lang=js"
export * from "./OnDemandAssessmentPurchasesClosed.vue?vue&type=script&lang=js"

import "./OnDemandAssessmentPurchasesClosed.vue?vue&type=style&index=0&id=7bf15bfa&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf15bfa"]])

export default __exports__